module.exports = "/_next/static/images/top-21fc6e3b92c192191c5aa53fdf68525a.jpeg";